const Schedule = {

  closeModalNew() {
    document.getElementById('session_modal').innerText = "";
  },
  closeAttendanceModalNew() {
    document.getElementById('attendance_modal').innerText = "";
  },

  stopPropagation(event) {
    event.stopPropagation();
  },

  openSessionModal(title, details, sessionId, scheduled) {
    document.getElementById('sessionModal').classList.remove('hidden');
    document.getElementById('sessionModalBackdrop').classList.remove('hidden');

    document.getElementById('sessionModalTitle').innerText = title;
    document.getElementById('sessionModalDetails').innerHTML = details;

    const cancelButton = document.getElementById('cancelButton');
    cancelButton.removeEventListener('click', this.cancelButtonClickHandler.bind(this));
    cancelButton.addEventListener('click', this.cancelButtonClickHandler.bind(this));

    this.updateScheduleButton(sessionId, scheduled);
  },

  closeModal() {
    document.getElementById('sessionModal').classList.add('hidden');
    document.getElementById('sessionModalBackdrop').classList.add('hidden');
  },

  cancelButtonClickHandler() {
    this.updateScheduleMessage('');
    Schedule.closeModal();
  },

  getCSRFToken() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  },

  updateScheduleButton(sessionId, scheduled) {
    const scheduleButton = document.getElementById('scheduleButton');
    if (!scheduleButton) {
      this.updateScheduleMessage('<a href="/auth/login">Please sign in to schedule</a>');
      return;
    }

    const unscheduleHandler = () => this.unscheduleButtonClickHandler(sessionId);
    const scheduleHandler = () => this.scheduleButtonClickHandler(sessionId);

    // Clone the scheduleButton
    const clonedButton = scheduleButton.cloneNode(true);

    // Replace the original scheduleButton with the clonedButton - removing any events
    scheduleButton.parentNode.replaceChild(clonedButton, scheduleButton);

    if (scheduled) {
      clonedButton.textContent = 'Unschedule';
      clonedButton.addEventListener('click', unscheduleHandler);
    } else {
      clonedButton.textContent = 'Schedule';
      clonedButton.addEventListener('click', scheduleHandler);
    }
  },

  updateScheduleMessage(message) {
    document.getElementById('scheduleMessage').innerHTML = message;
  },

  updateScheduleView(sessionId, scheduled) {
    const scheduledTick = document.getElementById('scheduledTick-' + sessionId);
    if (scheduledTick) {
      if (scheduled) {
        scheduledTick.classList.remove('hidden');
      } else {
        scheduledTick.classList.add('hidden');
      }
    }
  },
  unscheduleButtonClickHandler(sessionId) {
    fetch(`/schedule/session/${sessionId}/unschedule`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.getCSRFToken()
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.showSessionDetails(sessionId);
          this.updateScheduleMessage('Session unscheduled successfully');
          this.updateScheduleView(sessionId, false);
        } else {
          this.updateScheduleMessage('Unable to unschedule session');
        }
      })
      .catch(error => {
        this.updateScheduleMessage('An error occurred while unscheduling the session');
      });
  },

  scheduleButtonClickHandler(sessionId) {
    fetch(`/schedule/session/${sessionId}/schedule`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.getCSRFToken()
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.showSessionDetails(sessionId);
          this.updateScheduleMessage('Session scheduled successfully');
          this.updateScheduleView(sessionId, true);
        } else {
          this.updateScheduleMessage('Unable to schedule session');
        }
      })
      .catch(error => {
        this.updateScheduleMessage('An error occurred while scheduling the session');
      });
  },

  showSessionDetails(sessionId, date) {
    var dateParams = "";
    if (date) {
      dateParams = `?date=${date}`;
    }

    fetch(`/schedule/session/${sessionId}.json${dateParams}`)

      .then(response => response.json())
      .then(data => {
        var title = `${data.program.name}`;

        if (data.coach) {
          title = `${data.program.name} with ${data.coach.name}`;
        }

        const details = this.renderDetails(data);

        this.openSessionModal(title, details, data.id, data.scheduled);
      })
      .catch(error => console.error('Error fetching session:', error));
  },

  renderDetails(data) {
    const startDateTime = new Date(`${data.date}T${data.start_time}`);
    const endDateTime = new Date(`${data.date}T${data.end_time}`);
    const duration = (endDateTime - startDateTime) / (1000 * 60); // duration in minutes

    const details = `
      <p><strong>Location:</strong> ${data.location.name}</p>
      <p><strong>Time:</strong> ${startDateTime.toTimeString().slice(0, 5)} - ${endDateTime.toTimeString().slice(0, 5)} (${duration} minutes)</p>

        <p>
          <strong>Clients Registered</strong>
          <span class="inline-block text-sm">${Math.round(data.capacity * data.capacity_percentage / 100)} of ${data.capacity} registered</span>
          ${data.clients ? `
            ${data.clients.length ? data.clients.map(client => `<p>${client.name}</p>`).join('') : '<p>Nobody has registered, yet.</p>'}
          ` : ''}
        </p>
    `;

    return details;
  }


}

export default Schedule;
